import { Helmet } from "react-helmet-async";

const SITE = "https://grading.mascertified.com";
const DEFAULT_DESC =
  "MAS Grading is a professional trading card grading and certification service — precise grades, tamper-evident slabs, a live population registry, and instant online cert verification.";
const DEFAULT_IMG = `${SITE}/og-image.jpg`;

export default function Seo({
  title,
  description = DEFAULT_DESC,
  path = "",
  image = DEFAULT_IMG,
  type = "website",
  jsonLd,
  noindex = false,
}) {
  const url = `${SITE}${path}`;
  const fullTitle = title
    ? `${title} | MAS Grading`
    : "MAS Grading | Professional Trading Card Grading & Cert Verification";
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex,nofollow" : "index,follow,max-image-preview:large,max-snippet:-1"} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="MAS Grading" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
}
